import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import person from "../../../Resources/Images/person.jpg";
import "../../../Css/Messages.css";
import download from "../../../Resources/Images/download.svg";
//js
import { formatDate, CallService, modalAlert } from "../../../Js/Script";
import { UseUser } from "../../../Js/Context/userCntx";
import Config from "../../../Custom/Config";
export default function Message(props) {
  const { messagesData, writerUser, targetUser, title, status } = props;
  const stUser = UseUser();
  const navigate = useNavigate();
  const getBoxClassName = (systemTicket) => {
    switch (systemTicket) {
      case "closed":
      case "referred":
        return "info-box";
      case "Target":
        return "gray-box";
      case "Creator":
        return "success-box";
      default:
        return "";
    }
  };
  const getDvBoxClassName = (systemTicket) => {    
    switch (systemTicket) {
      case 1:
      case 2:
        return "dvInfo";
      case 3:
        return "dvGray";
      case 4:
        return "dvSuccess";
      default:
        return "";
    }
  };
  const getNameToDisplay = (message) => {
    console.log(message);
    
    if (stUser) {
      if (getDvBoxClassName(message.systemTicket) == "dvSuccess") {
        return writerUser.writerFirstName + " " + writerUser.writerLastName;
      } else {
        return message.respondedUserName + " " + message.respondedLastName;
      }
    }
  };

  function detectFileType(base64String) {
    // Decode the Base64 string
    const binaryString = atob(base64String);

    // Get the first few bytes
    const signature = binaryString.substring(0, 4);

    // File signatures
    const pdfSignature = "%PDF";
    const jpegSignature = "\xFF\xD8\xFF\xE0";
    const pngSignature = "\x89\x50\x4E\x47";
    const excelSignature = "PK\x03\x04"; // ZIP file format signature
    // Add more signatures as needed for other file types
    // Check against known file signatures
    if (signature === pdfSignature) {
      return "application/pdf";
    } else if (signature === jpegSignature || signature === pngSignature) {
      return "image/jpeg";
    } else if (signature === excelSignature) {
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    } else {
      // Unknown file type
      return "Unknown";
    }
  }
  // Function to handle file download
  function downloadFile(url, fileName) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => console.error("Error downloading file:", error));
  }
  return (
    <div id="dvMessages">
      {messagesData &&
        messagesData.length > 0 &&
        writerUser &&
        targetUser &&
        messagesData.map((message, index) => (
          <div
            key={index}
            className={`${getDvBoxClassName(message.systemTicket)} mt-15`}
          >
            <div className="box-title">
              <img src={person} className="smallImg"></img>
              <p style={{ marginRight: "17px" }}>
                <span>
                  (
                  {formatDate(message.regDateTime)[0] +
                    ":" +
                    formatDate(message.regDateTime)[1]}
                  )
                </span>
                
                <span>{getNameToDisplay(message)}</span>
              </p>
              {message.numberOfAnswer && (
                <p className="badge" id="box-badge">
                  پاسخ {message.numberOfAnswer}
                </p>
              )}
            </div>
            <div className={getBoxClassName(message.systemTicket)}>
              {message.regUserId === writerUser.userId && title && (
                <h4 className="mt-40">عنوان : {title}</h4>
              )}
              <p className="p-15 new-Line">
                 <pre className="new-Line">{message.message}</pre>
              </p>
              <div>
                {message.systemTicket && message.systemTicket === 2 ? (
                  <p>
                    تیکت ارجاع شد به{" "}
                    <strong>
                        {message && message.assignerFirstName && message.assignerLastName ? message.assignerFirstName + " " +message.assignerLastName : ""}
                    </strong>
                  </p>
                ) : message.systemTicket && !message.systemTicket === 1 ? (
                  <p>تیکت بسته شد.</p>
                ) : (
                  ""
                )}
              </div>
              {status && (
                <div>
                  <hr />
                  <small>وضعیت تیکت: {status}</small>
                </div>
              )}
            </div>
            {message.files &&
              message.files.map((files, index) =>
                files["files"] && files["files"].length
                  ? files["files"].map((file, fileIndex) => {
                      const fileUrl =
                        Config.Root +
                        (Config.Root === "https://localhost:7072"
                          ? file.fileUrl
                          : "/API" + file.fileUrl);
                      return (
                        <div key={fileIndex} style={{ margin: "5px" }}>
                          <img
                            className="box-downloadImg"
                            src={download}
                            alt="Download"
                          ></img>
                          <a
                            key={fileIndex}
                            id="downloadFile"
                            className="box-downloadFile"
                            href={fileUrl}
                            onClick={(e) => {
                              e.preventDefault();
                              downloadFile(
                                fileUrl,
                                Config.Root === "https://localhost:7072"
                                  ? file.fileUrl
                                  : "/API" + file.fileUrl
                              );
                            }}
                          >
                            دانلود <span>{file.fileName}</span>
                          </a>
                        </div>
                      );
                    })
                  : null
              )}
          </div>
        ))}
    </div>
  );
}
{
  /*href={`data:${detectFileType(message.attachments)};base64,${message.attachments }`}*/
}
//href={`data:image/jpeg;base64,${message.attachments }`}
